import logoAcademy from "../imgs/logo_academy.png";
import logoIte from "../imgs/logo_academy_ite.png";

const ITE_HOSTNAME = "cursosvirtuales.iteprevengo.com";

export const isIteDomain = () => window.location.hostname === ITE_HOSTNAME;

export const getBrand = () => {
    if (isIteDomain()) {
        return { name: "ITEPREVENGO", url: "https://www.iteprevengo.com/" };
    }
    return { name: "GESTIONASST", url: "https://gestionasst.pe/" };
};

export const getLogo = () => {
    if (isIteDomain()) {
        return logoIte;
    }
    return logoAcademy;
};
